// 巡检记录(详细信息)
import React, { useEffect, useState, useRef } from 'react'
import { json, useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeftOutlined, EnvironmentFilled, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { theme, Card, Tabs, Col, Row, Pagination, Spin, Tooltip, Image, Empty, Modal, Button, Drawer, App } from 'antd';
import { getNodeDataListHead, getNodeDataList, getNodeDataListInfo, getCompareImages } from '@/server/risk'
import noPhoto from '@/common/img/record/nodePhoto.svg'
import { basicPath } from '@/router/config';//引入路由基础路径
import { transformGCJ2WGS } from "@/common/js/common.js" //引入公共方法

function ViewImg (props) {
  const { getShow } = props
  const { message } = App.useApp();
  const location = useLocation();//接受传值数据
  const navigate = useNavigate();//路由跳转
  const params = props.tableInfo;
  const transfer = params.transfer;
  const token = localStorage.getItem('dock_token');
  const {
    token: {
      colorText,
      colorTextTertiary,
      colorPrimary },
  } = theme.useToken(); //获取主题颜色
  const [loading, setLoading] = useState(false);//加载中···
  const [cur, setCur] = useState(1);//当前页
  const [page, setPage] = useState(10);//每页多少条
  const [total, setTotal] = useState(0);//总条数
  const [mouseImgId, setMouseImgId] = useState('')//鼠标移入图片的ID
  const [typeList, setTypeList] = useState('')//头部选择器
  const [dataArr, setDataArr] = useState([])//所有数据
  const [clickImg, setClickImg] = useState('')//点击的图片
  const [visible, setVisible] = useState(false);

  const [openCompare, setOpenCompare] = useState(false) //定点巡检-打开对比对话框
  const [loadingCompare, setLoadingCompare] = useState(false)//定点巡检-加载中···
  const [compareInfo, setCompareInfo] = useState({})//定点巡检-对比数据


  const [seeImage, setSeeImage] = useState({
    isOpen: false,
    data: {},
    urlArr: [],
  })//seeImage组件相关信息


  // 搜索字段
  const [searchList, setSearchList] = useState({
    access_token: token,
    statid: transfer.statid,
    insIds: transfer.insIds,
    point_status: 0,
    page: 1,
    perpage: 12,
  })

  useEffect(() => {
    setLoading(true)
    if (transfer) {
      getgetAllListHead()
    }
    //eslint-disable-next-line
  }, [location.pathname])

  //获取所有数据头部
  const getgetAllListHead = async () => {
    let obj = {
      access_token: token,
      statid: searchList.statid,
      insIds: searchList.insIds,
    }
    let res = await getNodeDataListHead(obj)
    if (res.ret === 200) {
      let arr = []
      res.data.forEach(ele => {
        if (ele.total !== 0) {
          arr.push(ele)
        }
      });
      setTypeList(arr)
      getAllList()
    } else {
      message.warning(res.msg || `服务器开了小差，请重试`);
      setLoading(false)
    }
  }
  //获取所有数据
  const getAllList = async (obj) => {
    let res = await getNodeDataList(obj || searchList)
    if (res.ret === 200) {
      setCur(res.data.page)
      setPage(res.data.perpage)
      setTotal(res.data.total)
      setDataArr(res.data.items)
    } else {
      message.warning(res.msg || `服务器开了小差，请重试`);
    }
    setLoading(false)
  }
  // 获取对比数据
  const comparisonRouteImages = async (item) => {
    setCompareInfo()
    setLoadingCompare(true)
    let obj = {
      access_token: token,
      pointId: item.pointId
    }
    let res = await getCompareImages(obj)
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试')
      setLoadingCompare(false)
      setTimeout(() => {
        setOpenCompare(false)
      }, 3000)
    }
    let list = {
      newPic: res.data.newPic,
      oldPic: res.data.oldPic,
      newtime: res.data.newtime,
      oldtime: res.data.oldtime,
      PointName: item.PointName,
    }
    setCompareInfo({ ...list })
    setLoadingCompare(false)
  }

  //图片查看页
  const onPatrolMap = (item) => {
    const coordinate = {
      picUrl: item.picUrl,
      longitude: item.longitude, //经度
      latitude: item.latitude, //纬度
    }
    let d = transformGCJ2WGS({ lat: coordinate.latitude, lon: coordinate.longitude });
    coordinate.latitude = Number(parseFloat(d.lat).toFixed(7));
    coordinate.longitude = Number(parseFloat(d.lon).toFixed(7));
    window.sessionStorage.setItem('viewpictureid=' + item.pointId, JSON.stringify(transfer))
    window.sessionStorage.setItem('PatrolMap?id=' + item.pointId, JSON.stringify(coordinate))
    window.open(basicPath + '/PatrolMap?id=' + item.pointId, '_blank')
  }

  const showImg = (ele) => {
    console.log(ele);
    // let dom = document.getElementsByClassName('ant-image-preview-operations-wrapper ImageDom css-dev-only-do-not-override-8urctq')[0]
    let dom = document.getElementsByClassName('ant-image-preview-operations')[document.getElementsByClassName('ant-image-preview-operations').length - 1]
    let newDom = document.createElement('div')
    newDom.innerHTML = ele.PointName + '&nbsp;&nbsp;&nbsp;&nbsp;' + ele.addtime
    newDom.style = 'width:100%;text-align:center;margin-left:258px;'
    newDom.className = 'fs20 text_omitted1'
    dom.appendChild(newDom)
  }

  // 通过选项卡key获取数据
  const getDataByKey = (key) => {
    setLoading(true)
    let value = typeList.find((res, index) => index === key).value
    let obj = { ...searchList }
    obj.point_status = value
    getAllList(obj)
  }
  return (
    <Spin spinning={loading}>
      <div className='pdRL24 pdB24 ' style={{ color: colorText, boxSizing: 'border-box' }}>
        <div className='flex align_center marTB16' >
          <span onClick={() => {
            getShow(true)
          }}
            className='pointer'
          >
            <ArrowLeftOutlined />
          </span>
          <span className='fs20 fw500  marL16 lh28 pdTB6'>{transfer ? transfer.routeName : ``}</span>
          <span className='fs14 fw400 lh22 marL12 pdTB9' style={{ color: colorTextTertiary }}>
            巡检时间：{transfer.startTime ? transfer.startTime : ``} ~ {transfer.endTime ? transfer.endTime : `未结束`}
          </span>
        </div>
        <Card className="wid100" bodyStyle={{ padding: '12px 24px 24px 24px' }}>
          <Tabs
            defaultActiveKey="1"
            onTabClick={(key) => {
              getDataByKey(key)
            }}
            items={
              typeList
                ? typeList.map((typeList, index) => {
                  return {
                    key: index,
                    label: (
                      <div className='flex_row align_center'>
                        <div className='fw500 fs14 lh22 marR4'>
                          {typeList.label}
                        </div>
                        <div className='radius50' style={{ backgroundColor: '#262626' }}>
                          <span className=' fw400 fs12 lh20 radius49 pdRL8'>{typeList.total}</span>
                        </div>
                      </div>
                    ),
                  }
                }
                )
                : ''
            }
          >
          </Tabs>
          <div className='marB12'>
            <div style={{ display: JSON.stringify(dataArr) === '[]' ? `block` : `none` }}>
              <div className='flex jcc align_center wid100 hei100'>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              </div>
            </div>
            <div style={{ display: dataArr.length > 0 ? `block` : `none` }}>
              <Row gutter={24} >
                {
                  dataArr.map((ele, index) => {
                    return (
                      <Col span={6} key={index}>
                        <div className='pdB24'>
                          <div
                            className=''
                            onMouseOver={() => { setMouseImgId(ele.pointId); }}
                            onMouseLeave={() => {
                              setMouseImgId('')
                            }}
                          >
                            <div className='pos_rel'>
                              {
                                params.type === 4
                                  ? (
                                    <div>
                                      <img
                                        width='100%'
                                        className='radius8 wid100 hei100 pointer'
                                        alt='111'
                                        src={ele.handler_status === 0 ? noPhoto : ele.picUrl}
                                        onClick={() => {
                                          setVisible(true);
                                          setTimeout(() => {
                                            setClickImg(ele.picUrl);
                                            showImg(ele)
                                          }, 100)
                                        }}
                                      />
                                      <div style={{ height: '0' }}>
                                        <Image
                                          rootClassName='ImageDom'
                                          width='90%'
                                          style={{ display: 'none' }}
                                          className='radius8 wid100 hei100 pointer borderImageDom'
                                          alt='111'
                                          title='111'
                                          src={ele.handler_status === 0 ? noPhoto : clickImg}
                                          preview={ele.handler_status === 0 ? false : {
                                            visible,
                                            src: clickImg,
                                            onVisibleChange: (value) => {
                                              setVisible(value);
                                            },
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )
                                  : (
                                    <div className='pos_rel'>
                                      <Image
                                        width='100%'
                                        className='radius8 wid100 hei100 pointer'
                                        alt='111'
                                        src={ele.handler_status === 0 ? noPhoto : ele.picUrl}
                                        preview={ele.handler_status === 0 ? false : {
                                          visible,
                                          src: clickImg,
                                          onVisibleChange: (value) => {
                                            setVisible(value);
                                          },
                                        }}
                                      />
                                    </div>
                                  )
                              }
                              <div
                                className='radius8 pos_abs hei100 wid100 pd24 pointer'
                                onClick={() => {
                                  setClickImg(ele.picUrl)
                                  setVisible(true);
                                }}
                                style={{
                                  backgroundColor: 'rgba(0,0,0,0.45)',
                                  overflow: 'hidden', top: '0', left: '0',
                                  display: ele.pointId === mouseImgId && ele.handler_status !== 0 && params.type !== 4 ? `block` : `none`
                                }}
                              >
                                <div>
                                  <div className='flex'>
                                    <div className='fw400 fs12 lh20 flex_shrink0'>巡检时间：</div>
                                    <Tooltip placement="top" title={ele.addtime ? ele.addtime : `暂无信息`}>
                                      <div className='fw400 fs12 lh20 flex_auto text_omitted'>{ele.addtime ? ele.addtime : `暂无信息`}</div>
                                    </Tooltip>
                                  </div>
                                  <div className='flex'>
                                    <div className='fw400 fs12 lh20 flex_shrink0'>地理位置：</div>
                                    <Tooltip placement="bottom" title={ele.location ? ele.location : `暂无信息`}>
                                      <div className='fw400 fs12 lh20 flex_auto '
                                        style={{
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          display: '-webkit-box',
                                          WebkitLineClamp: 3,
                                          wordBreak: 'break-all',
                                          WebkitBoxOrient: 'vertical'
                                        }}
                                      >
                                        {ele.location ? ele.location : `暂无信息`}
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          <div className='flex jcsb marT4 align_center' style={{ padding: params.type === 4 ? `` : `0 8px` }}>
                            <span className='fw400 fs12 lh20'>{ele.PointName ? ele.PointName : ele.point_order ? ele.point_order : ''}</span>
                            <span
                              className='align_center'
                              style={{ color: '#1668dc', textDecoration: 'underline', display: params.type === 4 ? 'none' : 'block' }}
                              onClick={() => { onPatrolMap(ele) }}
                            >
                              <EnvironmentFilled className='pointer' style={{ height: '14px', width: '14px', color: colorPrimary }} />
                            </span>
                            <div style={{ display: params.type === 4 ? 'block' : 'none' }}>
                              <Button onClick={() => {
                                setOpenCompare(true)
                                comparisonRouteImages(ele)
                              }}>
                                对比
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    )
                  })
                }
              </Row>
              <div className='flex jcr'>
                <Pagination align='end' current={cur} pageSize={page} total={total} showTotal={total => `共 ${total} 条数据`}
                  onChange={
                    (current, pageSize) => { //选择当前页后执行
                      setCur(current);
                      setPage(pageSize);
                      let obj = { ...searchList };
                      obj.perpage = pageSize;
                      obj.page = current;
                      setSearchList({ ...obj });
                      getAllList(obj);
                    }
                  } />
              </div>
            </div>
          </div>


          {/* 对比 */}
          <Modal
            width='95vw'
            title={compareInfo?.PointName}
            bodyStyle={{ height: '70vh' }}
            open={openCompare}
            onCancel={() => { setOpenCompare(false) }}
            footer={null}
          >
            <Spin spinning={loadingCompare}>
              <Row className='wid100 hei100 '>
                <Col span={12}>
                  <div style={{ display: compareInfo?.oldPic ? 'block' : 'none' }}>
                    <div className='pointer flex align_center jcc'
                      onClick={() => {
                        setClickImg(compareInfo?.oldPic)
                        setVisible(true);
                      }}
                    >
                      <img alt='old'
                        style={{ width: '99%' }}
                        src={compareInfo?.oldPic}
                        preview={{
                          visible,
                          src: clickImg,
                          onVisibleChange: (value) => {
                            setVisible(value);
                          },
                        }}
                      />
                    </div>
                    <div className='flex jcr marRL8 fs20'>
                      {/* <span>航点名称</span> */}
                      <span>{compareInfo?.oldtime}</span>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ display: compareInfo?.newPic ? 'block' : 'none' }}>
                    <div className='pointer flex align_center jcc'
                      onClick={() => {
                        setClickImg(compareInfo?.newPic)
                        setVisible(true);
                      }}
                    >
                      <img
                        alt='new'
                        style={{ width: '99%' }}
                        src={compareInfo?.newPic}
                        preview={{
                          visible,
                          src: clickImg,
                          onVisibleChange: (value) => {
                            setVisible(value);
                          },
                        }}
                      />
                    </div>

                    <div className='flex jcr marRL8 fs20'>
                      {/* <span>航点名称</span> */}
                      <span>{compareInfo?.newtime}</span>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className='flex jcsa align_center' style={{ height: '70vh' }}>
                <div style={{ display: compareInfo?.oldPic ? 'none' : 'block' }} >
                  暂无图片
                </div>
                <div style={{ display: compareInfo?.newPic ? 'none' : 'block' }} className='flex_col jcr'>
                  暂无图片
                </div>
              </div>
            </Spin>
          </Modal>
        </Card >
      </div>
    </Spin >
  )
}
export default ViewImg